import { StyleSheet, Dimensions, Platform } from 'react-native'
import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const SCREEN_WIDTH = Dimensions.get('screen').width

const styles = StyleSheet.create({
    boldTitle: {
        fontSize: 24,
        ...Fonts.type.bold,
        paddingHorizontal: 20,
        color: Colors.dark_grey,
        marginTop: 36,
        marginBottom: 16,
    },
    graySubtitle: {
        fontSize: 16,
        paddingHorizontal: 20,
        color: Colors.dark_grey,
        marginBottom: 16,
    },
    image: {
        zIndex: 5,
        width: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? '100%' : SCREEN_WIDTH - 32,
        height: 'auto',
        // margin: 16,
    },
    cardTitle: {
        color: Colors.white,
        fontSize: Fonts.size.regular,
        marginVertical: 3,
        ...Fonts.type.bold
    },
    cardDescription: {
        color: Colors.white,
        fontSize: Fonts.size.regular,
        marginVertical: 3
    },
    marginHorizontal20: {
        marginHorizontal: 20
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 16
    },
})

export default styles;